module.exports = __webpack_public_path__ + "media/images/robot_alert-b49d3a8b.svg";